// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum DistributorRefundCandidateItemStatus {
  New = "NEW",
  Approved = "APPROVED",
  Processed = "PROCESSED",
}
export default DistributorRefundCandidateItemStatus;
